// extracted by mini-css-extract-plugin
module.exports = {"text_container":"Login_text_container__1GUGS","text":"Login_text__yxCrE","text_black":"Login_text_black__2_Gcf","button_container":"Login_button_container__1QRSP"};